// extracted by mini-css-extract-plugin
export default {"wrapper":"ProviderTag_wrapper--bVT","label":"ProviderTag_label--vlW","background":"ProviderTag_background--tak"};